
/// 创建光标为圆形
// 创建一个圆形光标的DataURL
export function createCircleCursorDataURL (radius, color) {
  // 创建一个Canvas元素
  var canvas = document.createElement('canvas')
  var ctx = canvas.getContext('2d')
  canvas.width = canvas.height = radius * 2
  // 绘制一个圆形
  ctx.beginPath()
  ctx.strokeStyle = color
  ctx.arc(radius, radius, radius, 0, 2 * Math.PI)
  ctx.fillStyle = color
  ctx.fill()
  // 将Canvas转换为DataURL
  return canvas.toDataURL('image/png')
}

/// 边缘坐标计算函数
export function getEdges (imageData) {
  const width = imageData.width
  const height = imageData.height
  const data = imageData.data
  const edges = []
  // 转换为灰度图像
  const grayscale = new Uint8Array(width * height)
  for (let i = 0; i < data.length; i += 4) {
    grayscale[i / 4] = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]
  }

  // 使用Sobel算子进行边缘检测
  const sobelH = [
    -1, 0, 1,
    -2, 0, 2,
    -1, 0, 1
  ]
  const sobelV = [
    -1, -2, -1,
    0, 0, 0,
    1, 2, 1
  ]

  const edges2 = new Uint8Array(width * height)
  for (let y = 1; y < height - 1; y++) {
    for (let x = 1; x < width - 1; x++) {
      const gradX =
                grayscale[x - 1 + (y - 1) * width] * sobelH[0] +
                grayscale[x + (y - 1) * width] * sobelH[1] +
                grayscale[x + 1 + (y - 1) * width] * sobelH[2] +
                grayscale[x - 1 + y * width] * sobelH[3] +
                grayscale[x + y * width] * sobelH[4] +
                grayscale[x + 1 + y * width] * sobelH[5] +
                grayscale[x - 1 + (y + 1) * width] * sobelH[6] +
                grayscale[x + (y + 1) * width] * sobelH[7] +
                grayscale[x + 1 + (y + 1) * width] * sobelH[8]

      const gradY =
                grayscale[x - 1 + (y - 1) * width] * sobelV[0] +
                grayscale[x + (y - 1) * width] * sobelV[1] +
                grayscale[x + 1 + (y - 1) * width] * sobelV[2] +
                grayscale[x - 1 + y * width] * sobelV[3] +
                grayscale[x + y * width] * sobelV[4] +
                grayscale[x + 1 + y * width] * sobelV[5] +
                grayscale[x - 1 + (y + 1) * width] * sobelV[6] +
                grayscale[x + (y + 1) * width] * sobelV[7] +
                grayscale[x + 1 + (y + 1) * width] * sobelV[8]

      const grad = Math.sqrt(gradX * gradX + gradY * gradY)
      edges2[x + y * width] = grad
    }
  }

  // 阈值化处理，以确定边缘
  const threshold = 10
  for (let i = 0; i < edges2.length; i++) {
    if (edges2[i] > threshold) {
      const x = (i % width)
      const y = Math.floor(i / width)
      // 这里可以返回坐标或者做其他处理
      // console.log(`Edge at (${x}, ${y}) with intensity ${edges[i]}`);
      edges.push({ x, y })
    }
  }
  return edges
}

/// 获取像素点颜色函数
export function getColor (x, y, imageData, width) {
  const i = point2Index(x, y, width)
  return [
    imageData.data[i],
    imageData.data[i + 1],
    imageData.data[i + 2],
    imageData.data[i + 3]
  ]
}

/// 对比两个像素点的颜色差别
export function diffColor (color1, color2) {
  return Math.abs(color1[0] - color2[0]) + Math.abs(color1[1] - color2[1]) + Math.abs(color1[2] - color2[2])
}
/// 计算x,y所在的数组位置i
export function point2Index (x, y, width) {
  return (y * width + x) * 4
}

/// canvas转图片
export function canvasToImage (cav) {
  // 创建一个新Canvas元素
  const newCanvas = document.createElement('canvas')
  const newContext = newCanvas.getContext('2d')

  // 设置新Canvas的宽度和高度与原始Canvas相同
  newCanvas.width = cav.width
  newCanvas.height = cav.height

  // 在新Canvas上绘制黑色背景
  // newContext.fillStyle = 'black'; // 设置背景颜色为黑色
  // newContext.fillRect(0, 0, newCanvas.width, newCanvas.height); // fillRect方法是直接在画布上绘制填充

  // 将原始Canvas上的图形绘制到新Canvas上
  newContext.drawImage(cav, 0, 0)
  // drawImage方法提供了多种在画布上绘制图像的方式，第一个参数允许任何的画布图像源

  // 将 Canvas 上的内容转换为DataURL
  const dataURL = newCanvas.toDataURL('image/png') // 指定要生成的图片格式
  // console.log(dataURL)
  return dataURL
}

export function brush (cav) {
    
}